// A member question already shown to its city reads "Complete" (founder
// 2026-11-04, "Yes to all 6, build them"; memberQuestionUtils, SHOWN ONCE).
// Violet, never green: the same shape as the Active pill beside it, and not
// a switch, because a Complete question is never shown again. Today's Active
// pill is unchanged.
import React from "react";
import { completeTooltip, completeLine, completeStatusLine, dealtLine } from "./memberQuestionUtils";

export const COMPLETE_PILL_CLASS = "bg-lilac-100 text-lilac-600 border border-lilac-600 px-24 py-4 radius-4 fw-medium text-sm";

/** The pill, with its tooltip. */
export const CompletePill = ({ item }) => (
  <span className={COMPLETE_PILL_CLASS} style={{ cursor: "default", whiteSpace: "nowrap" }} title={completeTooltip(item)}>
    Complete
  </span>
);

const Line = ({ text }) =>
  text ? (
    <div className="text-xs text-secondary-light" style={{ marginTop: 4 }}>
      {text}
    </div>
  ) : null;

/** The list's Status cell on a Complete row: the pill, then "Shown in Ottawa Tue, Nov 3". */
export const CompleteCell = ({ item }) => (
  <>
    <CompletePill item={item} />
    <Line text={completeLine(item)} />
  </>
);

/** The View page's Status on a Complete row: the pill, then "Shown in Ottawa on Tuesday, Nov 3 at 8 PM ET". */
export const CompleteStatusField = ({ item }) => (
  <>
    <CompletePill item={item} />
    <Line text={completeStatusLine(item)} />
  </>
);

/** Under the Active pill between the 7 PM deal and the drop: "Shows tonight in Ottawa at 8 PM ET". */
export const DealtLine = ({ item }) => <Line text={dealtLine(item)} />;
